export default __webpack_public_path__ + "static/media/Cardiac-chair.6fe211c9.svg";